import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./OrderConfirmation.scss";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const OrderConfirmation = () => {
  const navigate = useNavigate();
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");
  const raerAcess = localStorage.getItem("raerAcess");

  const [returnReason, setReturnReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [orderItems, setOrderItems] = useState([]);

  const handleCheckboxChange = (sku, count, name, price, productId, size) => {
    const isChecked = checkedProducts.some(
      (checkedProduct) => checkedProduct.sku === sku
    );

    let updatedCheckedProducts;
    let updatedOrderItems;

    if (isChecked) {
      updatedCheckedProducts = checkedProducts.filter(
        (checkedProduct) => !(checkedProduct.sku === sku)
      );
      updatedOrderItems = orderItems.filter((item) => !(item.sku === sku));
    } else {
      updatedCheckedProducts = [
        ...checkedProducts,
        { sku, productId, size, count, price },
      ];
      updatedOrderItems = [...orderItems, { sku, name, count, price }];
    }

    setCheckedProducts(updatedCheckedProducts);
    setOrderItems(updatedOrderItems);
  };

  console.log("->>>>>>>>>>", orderItems);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const { id } = useParams();
  const [order, setOrder] = useState([]);

  const fetchOrder = async () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getOrderById/${id}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          setOrder(response.data.data);
        }
        if (response?.data?.status) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    fetchOrder();
  }, [id]);

  const userData = JSON.parse(localStorage.getItem("user"));

  const handleReturn = () => {
    // Here you can handle the return logic

    handleCloseModal();
    console.log({ checkedProducts, orderItems });

    console.log(checkedProducts);
    if (checkedProducts.length == 0) {
      toast.warn("Select Return Product", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }

    let takeReturnReason = "";
    console.log("Returning product with reason:", returnReason);
    if (returnReason === "Other") takeReturnReason = otherReason;
    else takeReturnReason = returnReason;

    // Close the modal after handling return
    const config = {
      url: process.env.REACT_APP_BASE_URL + `return/addReturnRequest`,
      method: "post",
      data: {
        orderId: order?._id,
        products: checkedProducts,
        reasonOfReturn: takeReturnReason,
        user: userId,
        order_items: orderItems,
        order_id: order?.channel_order_id,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (response?.data?.status == true) {
          toast.success(
            "Order request received! We are processing it now. You will be updated shortly.",
            {
              position: "bottom-right",
              autoClose: 4000,
              pauseOnHover: true,
              draggable: true,
              theme: "dark",
            }
          );
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [orderStatus, setOrderStatus] = useState();
  const orderDets = () => {
    console.log(order?.shipp_orderId);
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/ship/orderDets/${id}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data?.shipments?.status);
        if (response?.data?.status) {
          setOrderStatus(response.data.data);
        }
        if (response?.data?.status) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    orderDets();
  }, []);

  return (
    <>
      <div>
        <div className="OC-main">
          <div className="OC-outer">
            <div className="OC-inner">
              <div className="section-1 row">
                <div className="sec-1-part-1 ">
                  {order?.checkReturnTrue &&
                  orderStatus?.shipments?.status == "DELIVERED" ? (
                    <h3>
                      Your order has been successfully canceled, and a refund
                      has been processed.
                    </h3>
                  ) : (
                    <h5>Thank you, your order has been placed</h5>
                  )}
                </div>
                <div className="sec-1-part-2 col-4">
                  {(order?.orderStatus == "PROCESSING" ||
                    order?.orderStatus == "COMPLETED") && (
                    <div className="button-outer">
                      <Link to={`/invoice/${id}`}>Download Invoice</Link>
                    </div>
                  )}
                </div>
              </div>
              <div className="section-2">
                <div className="sec-2-outer">
                  <h6>Hello {userData?.fullName},</h6>
                  <p>
                    Your order has been confirmed and will be shipping in the
                    next 3 Days.
                  </p>
                </div>
              </div>
              <div className="section-3">
                <div className="sec-3-outer">
                  <div className="sec-3-inner">
                    <div className="head">
                      <h6>Order Details:</h6>
                    </div>
                    <div className="mid row">
                      <div className="part-1 col-6">
                        <div className="part-head">
                          <p>Order ID:</p>
                          <p>Total Amount:</p>
                          <p>Payment Method:</p>
                        </div>
                        <div className="part">
                          <p>{order._id}</p>
                          <p>₹ {order?.total_amount}</p>
                          <p className="method">{order?.payment_method}</p>
                        </div>
                      </div>
                      <div className="part-2 col-6">
                        <div className="part-head">
                          {/* <p>Transaction ID :</p> */}
                          <p>Date:</p>
                          <p>Status:</p>
                        </div>
                        <div className="parts">
                          {/* <p>{order?.transaction_id?._id}</p> */}
                          {console.log(orderStatus?.shipments?.status)}
                          <p>
                            {new Date(order?.orderDate).toLocaleDateString()}
                          </p>
                          <p>{orderStatus?.shipments?.status || "pending"}</p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="body">
                      <div className="body-outer">
                        {order?.products?.map((product, index) => (
                          <div key={index} className="body-inner row">
                            <div className="image-outer  col-md-3 col-3">
                              <img
                                src={product?.productId?.image[0]}
                                alt={product?.productId?.productName}
                              />
                            </div>
                            <div className="content-outer  col-md-3 col-5 ">
                              <div className="content">
                                <p>{product?.productId?.productName}</p>
                                <div className="but-outer">
                                  <p>Qnt:</p>
                                  <p>{product?.count}</p>
                                </div>
                              </div>
                            </div>
                            <div className="price-outer  col-md-3 col-3 ">
                              <div className="price">
                                <p>
                                  Price : ₹{" "}
                                  {product?.productId?.price * product?.count}
                                </p>

                                <p>Color :{product?.productId?.color}</p>
                              </div>
                            </div>
                            {order?.checkReturnTrue &&
                              orderStatus?.shipments?.status == "DELIVERED" && (
                                <div className="checkbox-outer col-3">
                                  <h6>Select For Return</h6>
                                  <input
                                    type="checkbox"
                                    checked={checkedProducts?.some(
                                      (checkedProduct) =>
                                        checkedProduct?.productId ===
                                          product?.productId?._id &&
                                        checkedProduct?.sku === product?.sku
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        product?.sku,
                                        product?.count,
                                        product?.productId?.productName,
                                        product?.productId?.price *
                                          product?.count,
                                        product?.productId?._id,
                                        product?.size
                                      )
                                    }
                                  />
                                </div>
                              )}
                          </div>
                        ))}
                      </div>

                      {order?.checkReturnTrue &&
                        orderStatus?.shipments?.status == "DELIVERED" && (
                          <div className="return-button">
                            <button onClick={handleShowModal}>Return</button>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-4">
                <div className="sec-4-outer row">
                  <div className="part-2 col-12">
                    <div className="part-2-outer">
                      <div className="head">
                        <h6>Billing Details:</h6>
                      </div>
                      <div className="body">
                        <div className="part-1-body">
                          <p>Name:</p>
                          <p>Address:</p>
                          <p className="pin">Pin:</p>
                          <p>Contact No.:</p>
                          <p>
                            Amount:
                            {/* <span>₹ {order?.total_amount}</span> */}
                          </p>
                        </div>
                        <div className="part-2-body">
                          <p> {order?.billing_details?.fullName}</p>
                          <p>
                            {order?.billing_details?.address},{" "}
                            {order?.billing_details?.landmark},{" "}
                            {order?.billing_details?.city},{" "}
                            {order?.billing_details?.state}, India
                          </p>
                          <p> {order?.billing_details?.pincode || "452001"} </p>
                          <p>{order?.billing_details?.phone}</p>
                          <p className="amount">₹ {order?.total_amount}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-5">
                <div className="button-outer">
                  <Link to={`/myAccount`}>My Orders</Link>
                </div>
              </div>

              <div className="modal-container">
                <Modal
                  show={showModal}
                  onHide={handleCloseModal}
                  className="bottom-modal"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Select Return Reason</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group>
                      <Form.Control
                        as="select"
                        value={returnReason}
                        onChange={(e) => setReturnReason(e.target.value)}
                      >
                        <option value="">Select Reason</option>
                        <option value="Wrong size or fit">
                          Wrong size or fit
                        </option>
                        <option value="Received damaged or defective item">
                          Received damaged or defective item
                        </option>
                        {/* Add more options as needed */}
                        <option value="Other">Other</option>
                      </Form.Control>
                    </Form.Group>
                    {returnReason === "Other" && (
                      <Form.Group>
                        <Form.Label>Other Reason</Form.Label>
                        <Form.Control
                          type="text"
                          value={otherReason}
                          onChange={(e) => setOtherReason(e.target.value)}
                        />
                      </Form.Group>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                      Close
                    </Button>
                    <Button variant="primary" onClick={handleReturn}>
                      Return
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    </>
  );
};

export default OrderConfirmation;
